import { Eye, Users, MousePointer, CreditCard, UserCheck } from 'lucide-react';

interface FunnelStage {
  name: string;
  value: number;
  percentage: string;
  convertRate?: string;
  dropOffRate?: string;
}

interface ConversionFunnelProps {
  data: FunnelStage[];
  conversionRates?: { sku: string; rate: string }[];
}

export default function ConversionFunnel({ data, conversionRates }: ConversionFunnelProps) {
  const stageIcons = [Eye, Users, MousePointer, CreditCard, UserCheck];
  const stageColors = [
    'bg-brand-primary text-white',
    'bg-brand-primary text-white', 
    'bg-brand-primary text-white',
    'bg-brand-primary text-white',
    'bg-brand-primary text-white'
  ];

  return (
    <div className="space-y-8">
      {/* Customer Journey Funnel - Horizontal Flow */}
      <div className="space-y-6">
        <div>
          <h3 className="text-2xl font-bold text-brand-primary">Conversion Funnel, Overall and Per SKU</h3>
          <p className="text-brand-dark">Conversion flow from impression to subscription</p>
        </div>

        {/* Horizontal Funnel Flow */}
        <div className="relative overflow-x-auto">
          <div className="flex items-center gap-4 min-w-max px-4">
            {data.map((stage, index) => {
              const Icon = stageIcons[index] || Eye;
              const isLast = index === data.length - 1;
              
              return (
                <div key={index} className="flex items-center">
                  {/* Stage Card */}
                  <div className="bg-white rounded-xl p-4 shadow-sm border border-luxury-silver-light/40 w-56 h-48 flex-shrink-0">
                    <div className="flex flex-col items-center text-center space-y-2">
                      {/* Icon */}
                      <div className={`p-2 rounded-full ${stageColors[index]}`}>
                        <Icon className="w-5 h-5" />
                      </div>
                      
                      {/* Stage Info */}
                      <div className="space-y-1">
                        <p className="text-xs font-medium text-brand-dark">{stage.name}</p>
                        <p className="text-xl font-bold text-brand-primary">{stage.value.toLocaleString()}</p>
                        <p className="text-xs text-brand-dark">{stage.percentage}</p>
                      </div>

                      {/* Conversion/Drop-off Rates */}
                      {stage.convertRate && stage.dropOffRate && (
                        <div className="space-y-1">
                          <p className="text-xs text-brand-primary font-medium">{stage.convertRate}</p>
                          <p className="text-xs text-brand-dark font-medium">{stage.dropOffRate}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Arrow Connector */}
                  {!isLast && (
                    <div className="mx-2 flex items-center flex-shrink-0">
                      <div className="w-6 h-0.5 bg-luxury-silver-light"></div>
                      <div className="w-0 h-0 border-l-3 border-l-luxury-silver-light border-t-2 border-t-transparent border-b-2 border-b-transparent ml-1"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

    </div>
  );
}

